import type { ParticipantFile } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaCaretDown, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { ParticipantFileDeleteModal } from './ParticipantFileDeleteModal';
import { ParticipantFileEditModal } from './ParticipantFileEditModal';

interface Props extends ChakraV3.ButtonProps {
  file: ParticipantFile;
  isDisabled?: boolean;
}

export const ParticipantFileActionMenu = (props: Props) => {
  const { file, isDisabled, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantFileEditModal, {
                file,
              })
            }
            disabled={isDisabled}
            value='edit'
          >
            <FaPencilAlt />
            Edit
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantFileDeleteModal, {
                participantId: file.participantId,
                participantFileId: file.id,
                participantFileName: file.name,
              })
            }
            color='danger'
            disabled={isDisabled}
            value='delete'
          >
            <FaRegTrashAlt />
            Delete
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button disabled={isDisabled} variant='plain' size='sm' {...rest}>
          Actions
          <FaCaretDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
    </ChakraV3.Menu.Root>
  );
};
